var IncompleteSolutions = React.createClass({
  propTypes: {
    initialItems: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    pageSize: React.PropTypes.number
  },
  getDefaultProps() {
    return {
      initialItems: [],
      pageSize: 5
    }
  },
  getInitialState() {
    return {
      items: this.props.initialItems,
      isEditMode: false,
	  activeTab: "complete"
    }
  },
  pageClicked(num) {
    this.setState({pageNumber: num});
  },
  deleteClicked(item) {
    let { items } = this.state;
    let index = items.indexOf(item);

    let url = `${Config.contextPath}/app/core/solchecks.jsp`;
    let data = {
      operation: "delete",
      solutionid: item.solutionID,
      SToken: Config.csrf.value
    };

    $.post(url, data);

    // optimistic remove from array
    items.splice(index, 1);
    this.setState({items: items});
  },
  renderItem(item) {
    let { isEditMode } = this.state;

    let progress = Math.round((item.completedSteps.length / item.totalSteps) * 100);
    progress = <div className="text-muted small">{`${progress}% ${Labels.getLabel("complete")}`}</div>;

    return (
      <EditableListItem
        key={item.id}
        showDelete={isEditMode}
        onDelete={this.deleteClicked.bind(this, item)}>
        <a href={`${Config.contextPath}/app/portlets/results/viewsolution.jsp?solutionid=${item.solutionID}`}>
          <div>{item.title}</div>
          {isEditMode ? null : progress}
        </a>
        {isEditMode ? progress : null}
      </EditableListItem>
    )
  },
  editToggleClicked() {
    this.setState({isEditMode: !this.state.isEditMode});
  },
  navClicked(value) {
    this.setState({activeTab: value,
      isEditMode: false});
  },
  renderNav() {
    let {
      items,
      activeTab
    } = this.state;

    if (items.length == 0) return;

    return (
      <TabBar activeKey={activeTab} onChange={this.navClicked} className="-sm">
        <Tab eventKey="complete">{Labels.getLabel("Complete")}</Tab>
        <Tab eventKey="incomplete">{Labels.getLabel("Incomplete")}</Tab>
      </TabBar>
    )
  },
  renderToolbar() {
    let {
      items,
      isEditMode
    } = this.state;

    if (items.length == 0) return;

    return (
      <div className="aside__wrap aside__ctrls text-right">
        <EditLinkToggle
          onClick={this.editToggleClicked}
          editEnabled={isEditMode} />
      </div>
    )
  },
  render() {
    let { pageSize } = this.props;
    let {
      items,
      isEditMode,
	  activeTab
    } = this.state;
	
	const filteredItems = items.filter(item => {
		return activeTab === 'complete' ? item.completed : !item.completed;
	});

    let content = filteredItems.length ?
      <BasicPagerList
        className={classNames({"link-list": !isEditMode, "padded-list": isEditMode},  "-bordered", "-hover")}
        items={filteredItems}
        renderItem={this.renderItem}
        pageSize={pageSize} /> :
      <NoContent message={Labels.getLabel("No in progress solutions")} />

    return (
      <div>
        <h2 className="aside__title">
          {Labels.getLabel("Solutions")}
        </h2>

		{this.renderNav()}
        {this.renderToolbar()}

        {content}
      </div>
    )
  }
});
